/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import * as Accordion from '@radix-ui/react-accordion'
import * as Dialog from '@radix-ui/react-dialog'
import { ChevronDownIcon } from '@radix-ui/react-icons'
import React from 'react'

import { HeaderNavigationBarItem } from '@/components/e-commerce/header/links'
import { Link } from '@/i18n/navigation'
import { cn } from '@/utils/css'

/** A description of available properties for this component. */
type MobileNavigationMenuProps = {
  /** The links to display in the mobile navigation menu. */
  links: Array<HeaderNavigationBarItem>
}

/**
 * The mobile navigation menu for the e-commerce website.
 */
const MobileNavigationMenu: React.FC<MobileNavigationMenuProps> = ({ links }) => {
  return (
    <Accordion.Root type={'multiple'} className={'w-full'}>
      {links.map((item, index) => (
        <React.Fragment key={index}>
          {'submenu' in item ? (
            <Accordion.Item value={`item-${index}`} className={'border-b border-gray-200'}>
              <Accordion.Header>
                <Accordion.Trigger
                  className={cn(
                    'group flex w-full items-center justify-between px-4 py-2',
                    'text-left text-sm text-graphite-500 uppercase',
                    'data-[state=open]:bg-primary-500 data-[state=open]:text-white',
                  )}
                >
                  <span>{item.title}</span>
                  <ChevronDownIcon
                    className={'transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-180'}
                    aria-hidden
                  />
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content
                className={cn(
                  'overflow-hidden data-[state=open]:animate-slide-down data-[state=closed]:animate-slide-up',
                )}
              >
                <div className={'px-4 py-2'}>{item.submenu}</div>
              </Accordion.Content>
            </Accordion.Item>
          ) : (
            <div className={'border-b border-gray-200 px-4 py-2'}>
              <Dialog.Close asChild>
                <Link href={item.href} className={'block w-full text-left text-sm text-graphite-500 uppercase'}>
                  {item.title}
                </Link>
              </Dialog.Close>
            </div>
          )}
        </React.Fragment>
      ))}
    </Accordion.Root>
  )
}

export { MobileNavigationMenu }
